module.exports = __webpack_public_path__ + "static/img/user_4.545a65d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_4.png
// module id = q8H9
// module chunks = 0